<script>
	import { cn } from "./cn.js";
	import { createEventDispatcher } from "svelte";

	// 팝업 셸. open으로 표시, 오버레이/닫기 버튼 클릭 시 close 이벤트.
	export let open = false;
	export let title = "";
	let className = "";
	export { className as class };

	const dispatch = createEventDispatcher();
	const close = () => dispatch("close");

	// cn()은 tailwind-merge가 아니라 단순 join이라, 호출부가 넘긴 max-w-*와 기본 max-w-lg가
	// 둘 다 클래스에 남는다(승자는 CSS 소스 순서에 의존 → 빌드마다 흔들림). 호출부가 폭을
	// 지정하면 기본값을 빼서 충돌 자체를 없앤다.
	$: hasMaxW = /(?:^|\s)tw-max-w-/.test(className);
</script>

{#if open}
	<!--
		⚠️⚠️ `!tw-m-0` 을 빼지 말 것. 이 팝업은 호출한 컴포넌트가 있는 자리에 그대로 렌더되는데,
		그 부모가 `tw-space-y-*` 를 쓰고 있으면 **`position:fixed` 인 이 요소에도 margin-top 이 붙는다**
		(space-y 는 `> * ~ *` 규칙이라 위치지정 방식을 가리지 않고, fixed 요소도 margin 은 그대로 먹는다).
		그러면 `inset-0` 인데도 딤이 화면 위쪽 N px 를 덮지 못하고 아래로 밀린다
		(허브 운영자 화면 실측: space-y-5 의 20px 만큼 밀려 상단 띠가 안 가려졌다).
		⚠️ `tw-m-0` 으로는 안 된다 — space-y 규칙(`.tw-space-y-5 > :not([hidden]) ~ :not([hidden])`)이
		   특이도 (0,3,0) 이라 (0,1,0) 인 `tw-m-0` 을 이긴다. important 가 필요하다.
	-->
	<div class="tw-fixed tw-inset-0 tw-z-[1000] tw-flex tw-items-center tw-justify-center tw-p-4 !tw-m-0">
		<!-- 딤을 진하게 + 블러: 팝업 표면(card)이 앱 캔버스(background)와 같은 계열이라
		     약한 딤이면 팝업이 페이지에 묻힌다. 뒤를 확실히 눌러 팝업을 띄운다. -->
		<div class="tw-absolute tw-inset-0 tw-bg-black/70 tw-backdrop-blur-sm" on:click={close} />
		<div
			class={cn(
				"tw-relative tw-z-10 tw-flex tw-max-h-[90vh] tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-xl tw-bg-card tw-text-card-foreground tw-shadow-2xl tw-ring-1 tw-ring-border",
					hasMaxW ? "" : "tw-max-w-lg",
				className,
			)}
		>
			{#if title || $$slots.header}
				<div class="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-border tw-px-6 tw-py-4">
					<slot name="header">
						<h2 class="tw-m-0 tw-text-lg tw-font-semibold tw-text-foreground">{title}</h2>
					</slot>
					<button
						type="button"
						class="tw-cursor-pointer tw-text-muted-foreground hover:tw-text-foreground"
						on:click={close}
						aria-label="닫기">✕</button
					>
				</div>
			{/if}
			<div class="tw-overflow-y-auto tw-p-6">
				<slot />
			</div>
			{#if $$slots.footer}
				<div class="tw-flex tw-justify-end tw-gap-2 tw-border-t tw-border-border tw-px-6 tw-py-4">
					<slot name="footer" />
				</div>
			{/if}
		</div>
	</div>
{/if}
